export default {
  "content": "<title>Color Wand</title><rect x=\"280.48\" y=\"122.9\" width=\"63.03\" height=\"378.2\" rx=\"31.52\" transform=\"rotate(-45 312.002 311.994)\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M178.38 178.38a31.64 31.64 0 000 44.75L223.25 268 268 223.25l-44.87-44.87a31.64 31.64 0 00-44.75 0z\"/><path d=\"M48 192h48M90.18 90.18l33.94 33.94M192 48v48m101.82-5.82l-33.94 33.94M124.12 259.88l-33.94 33.94\" class=\"ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};